import React from 'react';
import { Platform } from 'react-native';
import LoanDetailsScreenWeb from '@/modules/profile/components/LoanDetailsScreenWeb';
import { LoanDetailsScreen } from '@/modules/profile/components/LoanDetailsScreen';

export default function LoanDetailsRoute() {
    if (Platform.OS === 'web') {
        return <LoanDetailsScreenWeb />;
    }
    return <LoanDetailsScreen />;
}